export default __webpack_public_path__ + "static/media/Satisfaccion.de8c73e2.svg";